import React, { createContext, useContext, useState, useEffect } from 'react';
import { councilAuth } from '../services/api';

const CouncilAuthContext = createContext(null);

export function CouncilAuthProvider({ children }) {
  const [council, setCouncil] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('council_token');
    if (token) {
      councilAuth.me()
        .then((res) => setCouncil(res.data))
        .catch(() => localStorage.removeItem('council_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await councilAuth.login({ email, password });
    localStorage.setItem('council_token', res.data.token);
    setCouncil(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('council_token');
    setCouncil(null);
  };

  return (
    <CouncilAuthContext.Provider value={{ council, loading, login, logout }}>
      {children}
    </CouncilAuthContext.Provider>
  );
}

export function useCouncilAuth() {
  return useContext(CouncilAuthContext);
}
